<template>
    <notifications position="top right">
        <template #body="props">
            <div class="toast d-block mb-1">
                <div class="toast-header">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="feather feather-alert-circle bd-placeholder-img rounded me-2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                    <strong class="me-auto" v-html="props.item.title"></strong>
                    <button type="button" class="ml-2 mb-1 bg-transparent text-white border-0" @click="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="toast-body" v-html="props.item.text"></div>
            </div>
        </template>
    </notifications>
</template>

<script>
export default {
    name: "FlashMessages",
    data(){
        return {
            titles : {
                success : 'Sucesso !!!',
                error : 'Oops! algo deu errado.'
            }
        }
    },
    watch: {
        '$page.props.flash': {
            handler(flashes) {
                _.each(flashes, (flash, typeNotify) => {
                    if (flash === null) return
                    _.each(flash, (message) => {
                        this.$notify({
                            type: typeNotify,
                            title: this.titles[typeNotify],
                            text: message,
                            duration: 10000
                        });
                    })
                })
            },
        },
    },
}
</script>

<style scoped>

.vue-notification-group {
    position: fixed !important;
    top: 80px !important;
    right: 20px !important;
    z-index: 99999 !important;
}

</style>
